import type { JSX } from 'react'
import { seasonColors } from './shared'

const leafPath = 'M0-6C3.4-4.4 5-1.2 4.2 1.8C3.4 4.2 1.4 5.4 0 6C-1.4 5.4-3.4 4.2-4.2 1.8C-5-1.2-3.4-4.4 0-6Z'

export function AutumnRoofLoad(): JSX.Element {
  const { orange, rust, ochre } = seasonColors
  const leaves: [number, number, number, string][] = [
    [138, 115, 70, orange],
    [148, 114.6, 115, rust],
    [205, 115, 80, ochre],
    [247, 114.8, 100, orange],
    [257, 114.4, 60, rust],
    [263, 115.2, 95, ochre],
    [296, 130, 75, orange],
    [389, 179.4, 100, rust],
  ]
  return (
    <g>
      {leaves.map(([x, y, angle, color]) => (
        <path
          key={`${x} ${y}`}
          transform={`translate(${x} ${y}) rotate(${angle}) scale(1 0.55)`}
          fill={color}
          d={leafPath}
        />
      ))}
    </g>
  )
}
